<template>
  <div class="pa-3 flex">
    <div class="title mb-3">
      Batches publication of indemnities
    </div>
    <div id="back">
      <router-link
        :to="{name: 'payments-payments-index'}"
        class="link-unstyled py-2 no-printable mb-3"
        style="width: max-content"
      >
        <v-icon
          color="primary"
          size="16"
        >
          mdi-arrow-left
        </v-icon>
        Back to the list of indemnities
      </router-link>
    </div>
    <div>
      <section
        id="to-manage"
        class="mt-4"
      >
        <div class="sub-filters">
          <v-select
            v-model="filters.status"
            label="Status of the batches"
            solo
            single-line
            hide-details
            :items="status"
            item-text="name"
            item-value="value"
            class="w300p not-flex"
            @change="onListFiltersChange"
          />
          <a @click="resetSubFilters">Reset filters</a>
        </div>
        <div id="list">
          <v-btn
            id="refresh"
            color="primary"
            @click="refreshBatches"
          >
            <v-icon>mdi-refresh</v-icon><span>Refresh list</span>
          </v-btn>
          <batches-list
            v-if="fullyLoaded"
            ref="batchesList"
            :status="filters.status"
          />
        </div>
      </section>
    </div>
  </div>
</template>
<script>
  import Consts from '@/consts'
  import GlobalMixin from "@/mixins/global"
  import Params from '@/api/params'
  import BatchesList from '@/components/payments/payments/Batches/Batches'
  import DateMixin from '@/mixins/date'

  export default {
    components: {BatchesList},
    mixins: [GlobalMixin, DateMixin],
    data() {
      return {
        filters: {
          status: null,
          user_id: null,
        },
        status: [
          {value: null, name: 'All'},
          {value: Consts.BATCHES_STATUS.WAITING, name: 'Waiting'},
          {value: Consts.BATCHES_STATUS.PROCESSING, name: 'Processing'},
          {value: Consts.BATCHES_STATUS.FINISHED, name: 'Completed'}
        ],
        fullyLoaded: false
      }
    },
    async mounted() {
      const storedFilters = this.getStoredObject('indemnities_batches.sub_filters')
      if(storedFilters) {
        this.filters = Object.assign(this.filters, storedFilters)
      }
      this.fullyLoaded = true
    },
    methods: {
      async loadTrainers() {
        const {data} = await Params.getList("users", {application: this.filters.application.value, sortBy: 'firstname'})
        this.trainers = data
      },
      onListFiltersChange() {
        // eslint-disable-next-line no-unused-vars
        this.setStoredObject("indemnities_batches.sub_filters", this.filters)
        this.refreshBatches(true)
      },
      resetSubFilters() {
        this.filters.status = null
        this.onListFiltersChange()
      },
      /**
       * Au départ j'utilisais un :key avec la dernière date de filtrage
       * pour forcer l'actualisation des sessions
       * mais ça faisait plein de merdes, en particulier des double-appels à l'API
       * Solution : appeler le refresh du fils par le parent
       * le nextTick est important, sinon le fils n'a pas le temps de s'actualiser au niveau des props
       */
      refreshBatches(filtered = false) {
        this.$nextTick(() => {
          this.$refs.batchesList && this.$refs.batchesList.fetch(filtered ? 'filters' : 'local')
        })
      }
    }
  }
</script>
<style scoped lang="sass">
  #filters
    display: flex
    flex-direction: row
    align-items: center
    justify-content: start

    .v-input
      width: 250px
      flex: 0 0 auto !important

  #stats
    display: flex
    flex-direction: row
    justify-content: space-around
    flex-wrap: wrap

    .stat
      width: 25%
      min-width: 250px
      display: flex
      flex-direction: column
      background-color: white
      padding: 10px
      margin-top: 10px

      .figure
        font-weight: bold
        color: #f4b944
        font-size: 64px
        text-align: center

      .subtitle
        text-align: center
        color: #333333
        font-size: 1.1rem

      .sub-footer
        display: flex
        flex-direction: row
        justify-content: flex-end

        &.centered
          justify-content: center

        .alert
          margin-right: 5px
          width: 40px
          height: 40px
          font-size: 40px !important
          color: tomato

        .badge
          background-color: tomato
          color: white
          font-weight: bold
          display: flex
          font-size: 0.85rem
          justify-content: center
          align-items: center
          padding: 1px 6px
          border-radius: 25px
          align-self: flex-start

  .sub-filters
    padding: 10px
    display: flex
    flex-direction: row
    justify-content: flex-start
    align-items: center
    flex-wrap: wrap

    > *
      width: 350px
      margin-right: 10px

      &.date
        width: 200px
      &.switch
        width: 270px
    a
      text-decoration: underline

  .w300p
    width: 300px
  .not-flex
    flex: none

  .inside-table
    border-collapse: collapse
    width: 100%

    tr:nth-child(event)
      background-color: #FAFAFA
    td
      border: 1px solid #F1F1F1
      padding: 10px 5px

  #refresh i
    margin-right: 5px


</style>
